module.exports = __webpack_public_path__ + "static/media/prepurchaseIco_Selected.20ca0ac8.svg";